import { z } from 'zod';

/**
 * Newsletter subscription request payload schema
 *
 * Validates data sent to CRM API for newsletter subscription.
 */
export const NewsletterSubscriptionSchema = z.object({
  email: z.string().email(),
  firstname: z.string().min(1),
  lastname: z.string().min(1),
  gender: z.enum(['', 'male', 'female']),
  zip: z.string().min(1),
  birthdate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
    .optional(),
  source: z.literal('checkout'),
  adults: z.string(),
  children: z.string(),
  productId: z.string().min(1),
});

export type NewsletterSubscriptionPayload = z.infer<typeof NewsletterSubscriptionSchema>;

/**
 * Newsletter subscription result
 *
 * Returned by subscribeToNewsletter function.
 */
export interface NewsletterSubscriptionResult {
  success: boolean;
  error?: string;
}
